export const getAppEmbeddedState = (): boolean => {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)

    // If location has language param, then it mean it's embedded
    return !! urlParams.get('language')
}
